import React, { useCallback, useEffect, useState } from "react";

import { Formik, useFormik } from "formik";
import { Button, Form, Tabs, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Col, FormButtons, FormDropdown, FormInputDate, FormInputText, FormTextArea, Whitespace } from "components";

import useFetch from "../../../../hooks/useFetch";
import { FormCheckbox } from "../../../../common";

import { Toast } from "../../../../utils";
import { Metrics } from "../../../../configs";
import { presignedUrl, saveVideoToTraining } from "../../../../services/course";
import { findQuestionsRequest } from "../../../../services/question";
import { findTrainingsByTopicActiveRequest } from "../../../../services/training";
import axios from "axios";

const { TabPane } = Tabs;

const TrainingForm = ({ handleSubmitForm, initialValues, handleCancel }) => {
  const [loading, setLoading] = useState();
  const [uploading, setUploading] = useState();
  const [fileList, setFileList] = useState([]);
  const [trainings, setTrainings] = useState([]);

  const formik = useFormik({
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
    initialValues: initialValues,
  });

  const [{ isFetching, data: questions }] = useFetch(findQuestionsRequest, "", true, null);

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList((fl) => [...fl, file]);
      return false;
    },
    fileList,
  };

  const handleUpload = useCallback(async () => {
    try {
      setUploading(true);
      const payloadPresigned = {
        fileType: fileList[0].type,
        fileName: fileList[0].name,
      };

      const { data } = await presignedUrl(payloadPresigned);

      const response = await axios.put(data.url, fileList[0], {
        headers: {
          'Content-Type': fileList[0].type,
        },
      });

      const uploadedUrl = response.config.url.split('?')[0];

      const payloadSave = {
        ...payloadPresigned,
        url: uploadedUrl,
      };

      const resSave = await saveVideoToTraining(initialValues.id, payloadSave);

      if (resSave?.data?.urlFile) {
        formik.setFieldValue("ds_url_video", resSave?.data?.urlFile);
      }
      Toast.showSuccessMessage("Arquivo enviado com sucesso!");
      return resSave.data;
    } catch (error) {
      Toast.showErrorMessage("Erro ao enviar o arquivo");
    } finally {
      setUploading(false);
    }
  }, [fileList, initialValues]);

  const getTrainingsByTopicId = async () => {
    try {
      setLoading(true);
      const { data } = await findTrainingsByTopicActiveRequest(initialValues.topico_id);
      setTrainings(data);
    } catch (error) {
      console.log(56, error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (name, value) => {
    formik.setFieldValue(name, value);
  };

  useEffect(() => {
    getTrainingsByTopicId();
  }, [initialValues]);

  return (
    <Formik enableReinitialize initialValues={formik.initialValues} onSubmit={formik.handleSubmit}>
      {({ handleSubmit, values, resetForm, initialValues }) => (
        <Form>
          {initialValues.id && (
            <Col style={{ backgroundColor: "#F0F2F5", padding: Metrics.spacingMD, marginBottom: Metrics.spacingMD }}>
              <span>
                <b>Carregar mídia do treinamento</b>
              </span>
              <Col style={{ justifyContent: "center", alignItems: "center" }}>
                <Upload {...props}>
                  <Button icon={<UploadOutlined />}>Selecionar arquivo</Button>
                </Upload>
                <Button onClick={handleUpload} disabled={fileList.length === 0 || uploading} loading={uploading} style={{ marginTop: 16 }}>
                  {uploading ? "Carregando..." : "Carregar"}
                </Button>
              </Col>
            </Col>
          )}
          <FormInputText name="ds_titulo" label="Título" required value={formik.values.ds_titulo} onChange={(e) => handleChange("ds_titulo", e)} />
          <FormTextArea label="Resumo" name="ds_resumo" required value={formik.values.ds_resumo} onChange={(e) => handleChange("ds_resumo", e.target.value)} />
          <FormInputText name="ds_url_video" label="Url do Vídeo" required value={formik.values.ds_url_video} onChange={(e) => handleChange("ds_url_video", e)} />

          <FormDropdown list={trainings} propertyValue="id" disabled={loading} name="precedente_id" propertyLabel="ds_titulo" value={formik.values.precedente_id} label="Treinamento precedente" placeholder="Selecione o treinamento que é pré-requisito deste" onChange={(e) => handleChange("precedente_id", e)} />

          <Whitespace height={Metrics.spacing.lg} />
          <FormInputText type="number" label="Porcentagem de acerto do precedente" name="pr_acerto_precedente" value={formik.values.pr_acerto_precedente} onChange={(e) => handleChange("pr_acerto_precedente", e)} />
          <FormInputDate label="Data início" name="dt_inicio" value={formik.values.dt_inicio} onChange={(e) => handleChange("dt_inicio", e)} />
          <FormInputDate label="Data fim" name="dt_fim" value={formik.values.dt_fim} onChange={(e) => handleChange("dt_fim", e)} />
          <FormCheckbox label="Aula presencial" name="is_in_person" value={formik.values.is_in_person} onChange={(e) => handleChange("is_in_person", e)} />
          <FormButtons
            bt2={{
              label: "Salvar",
              onClick: () => {
                handleSubmit(formik.values);
                setTimeout(() => resetForm(), 0);
              },
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

export default TrainingForm;
